import React, { useState, useEffect } from 'react';
import BrowserUpgrade from '../../../dumb/utils/browser-upgrade/BrowserUpgrade';

export const BrowserUpgradeContainer = () => {

    const [pcomment, setData] = useState('');
    const [className, setClassName] = useState('browserok');
    /*ie version library */
    var ie = require('ie-version');

    useEffect(() => {
        
        /*if ie tell user to upgrade his browser */
        if (ie.version && ie.version <= 9) {

            fetch("api/jsonFiles/alertMessages.json")
                .then(response => response.json())
                .then(data => {

                    setData(data[0])
                    setClassName('browserupgrade')
                    // console.log(pcomment)
                })
            }
        }
    );

    return <BrowserUpgrade.upgrd className = {className} pcomment = {pcomment} />
}